import { IBusStopData } from "@/domain/entities/busStop";
import { BusStopMarker } from "@/types";
import { Ref, ref } from "vue";

interface UseSelectedBusStopMarker {
  selectedBusStopMarker: Ref<any>;
  getSelectedBusStopMarkerImage: () => any;
  createSelectedBusStopMarker: (
    map: any,
    latitude?: number,
    longitude?: number,
    infoWindowContent?: string
  ) => void;
  removeSelectedBusStopMarker: () => void;
  updateSelectedBusStopMarker: (busStopMarker: BusStopMarker) => void;
}

export const useSelectedBusStopMarker = (
  createMarker: (
    lat: number,
    lng: number,
    markerImage: () => any,
    zIndex: number
  ) => any,
  createInfoWindow: (marker: any, infoWindowContent: string) => void,
  updateMarkerStyle: (
    marker: any,
    markerImage: () => any,
    zIndex: number
  ) => void,
  getBusStopMarkerImage: () => any,
  emitOnSelectedBusStopMarker: (busStop: IBusStopData) => void
): UseSelectedBusStopMarker => {
  const selectedBusStopMarker = ref<any>();

  const getSelectedBusStopMarkerImage = () => {
    return {
      url: require("@/assets/icons/marker_selected.svg"),
      size: new window.naver.maps.Size(20, 32),
      origin: new window.naver.maps.Point(0, 0),
      anchor: new window.naver.maps.Point(10, 16),
    };
  };

  const createSelectedBusStopMarker = (
    map: any,
    latitude?: number,
    longitude?: number,
    infoWindowContent?: string
  ) => {
    if (!latitude || !longitude) return;

    selectedBusStopMarker.value = createMarker(
      latitude,
      longitude,
      getSelectedBusStopMarkerImage,
      200
    );
    selectedBusStopMarker.value.setMap(map);

    if (infoWindowContent?.length) {
      createInfoWindow(selectedBusStopMarker.value, infoWindowContent);
    }
  };

  const removeSelectedBusStopMarker = () => {
    selectedBusStopMarker.value?.setMap(null);
  };

  const isSameLatLng = (markerA: any, markerB: any): boolean => {
    const posA = markerA.getPosition();
    const posB = markerB.getPosition();
    return posA.lat() === posB.lat() && posA.lng() === posB.lng();
  };

  const updateSelectedBusStopMarker = (busStopMarker: BusStopMarker) => {
    // 기존에 선택된 마커를 재선택하는 경우 무시한다.
    if (isSameLatLng(selectedBusStopMarker.value, busStopMarker.marker)) return;

    if (selectedBusStopMarker.value) {
      // 기존에 선택된 마커의 이미지를 기본 이미지로 변경
      updateMarkerStyle(
        selectedBusStopMarker.value,
        getBusStopMarkerImage,
        100
      );
    }

    // 현재 선택한 마커의 이미지는 선택 이미지로 변경
    updateMarkerStyle(busStopMarker.marker, getSelectedBusStopMarkerImage, 200);

    // 기존에 선택된 마커를 현재 선택된 마커 객체로 변경
    selectedBusStopMarker.value = busStopMarker.marker;

    emitOnSelectedBusStopMarker(busStopMarker.busStop);
  };

  return {
    selectedBusStopMarker,
    getSelectedBusStopMarkerImage,
    createSelectedBusStopMarker,
    removeSelectedBusStopMarker,
    updateSelectedBusStopMarker,
  };
};
